import React from "react";
import { useTranslation } from "react-i18next";

export default function FilterResumeList({
  filterObject,
  setFilterObject,
  onRemoveFilter,
  onClearAll
}) {
  let { t } = useTranslation();

  function removeFilter(key) {
    if (Object.keys(filterObject).length === 1) {
      clearFilters();
      return;
    }

    let _filterObject = { ...filterObject };
    delete _filterObject[key];
    setFilterObject(_filterObject);
    onRemoveFilter && onRemoveFilter(key);
  }

  function clearFilters() {
    setFilterObject({});
    onClearAll && onClearAll();
  }

  return (
    <>
      {filterObject &&
        Object.keys(filterObject).map((key) => (
          <span className="rounded-pill bg-ligth p-2  text-dark  ">
            {filterObject[key]}{" "}
            <i
              title={t("Delete")}
              onClick={() => removeFilter(key)}
              class="bi bi-x-lg"
            />
          </span>
        ))}

      {filterObject && Object.keys(filterObject).length > 1 && (
        <span className="rounded-pill bg-ligth p-2  text-dark  ">
          {t("Clear All")}
          <i
            title={t("Clear All")}
            onClick={() => clearFilters()}
            class="bi bi-x-lg"
          />
        </span>
      )}
    </>
  );
}
